import { render, staticRenderFns } from "./UniversityPreviewModal.vue?vue&type=template&id=ed71a03c&"
import script from "./UniversityPreviewModal.vue?vue&type=script&lang=js&"
export * from "./UniversityPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports